import $ from 'jquery';

$('.language-menu__select').on('change', function () {
    let regionId = $(this).val();
    let $subSelects = $(this).closest('.language-menu__selects').find('.language-menu__sub-select-wrap');

    $subSelects.removeClass('language-menu__sub-select-wrap--active');
    $subSelects.find('select').each(function () {
        let firstValue = $(this).find('option').eq(0).attr('value');
        $(this).val(firstValue).trigger('change');
    });

    let $activeSubSelect = $(this).closest('.language-menu__selects').find('.language-menu__sub-select-wrap[data-language-id="'+ regionId +'"]');

    if($activeSubSelect.length > 0) {
        $activeSubSelect.addClass('language-menu__sub-select-wrap--active');
    } else {
        $(this).closest('.language-menu__selects').find('.language-menu__sub-select-wrap.language-menu__sub-select-wrap--default').addClass('language-menu__sub-select-wrap--active');
    }
})

$('.language-menu__select-submit').on('click', function (e) {
    e.preventDefault();

    let link = $(this).closest('.language-menu').find('.language-menu__sub-select-wrap--active select').val();

    if(link !== '') {
        var date = new Date();

        // 100 years but will likely be max 400 days in most browsers
        date.setTime(date.getTime() + (100*365*24*60*60*1000));
        document.cookie = "region-selected=1;path=/;expires="+date.toUTCString()+";";
        window.location.href = link;
    }
})

$('.language-switch__item--current').on('click', function (e) {
    e.preventDefault();
    if($(this).siblings('.language-switch__items').find('.language-switch__dropdown-item').length > 0) {
        $(this).siblings('.language-switch__items').toggleClass('language-switch__items--show')
    }
})
$('.region-toggle').on('click', function (e){
    e.preventDefault();
    $.magnificPopup.open({
        items: {
            src: '#language-menu'
        },
        type: 'inline'
    });
})



if(getCookie('region-selected') !== '1') {
    $('#language-menu').addClass('language-menu--init');

    $.magnificPopup.open({
        items: {
            src: '#language-menu'
        },
        closeOnBgClick: false,
        enableEscapeKey: false,
        type: 'inline'
    });
}

$('.language-menu__item').on('click', function (e) {
    let langId = $(this).data('language-id');
    let $langMenu = $(this).closest('.language-menu')
    let langName = $(this).text();

    if(langId !== '' && $langMenu.hasClass('language-menu--init')) {
        e.preventDefault();
        $langMenu.find('.language-menu__sublist').removeClass('language-menu__sublist--show');
        $langMenu.find('.language-menu__sublist[data-language-id="'+ langId +'"]').addClass('language-menu__sublist--show');
        $langMenu.addClass('language-menu--open-sublist')
        $langMenu.find('.language-menu__back').text(langName);
    }
});

$('.language-menu__back').on('click', function (e) {
        e.preventDefault();
        let $langMenu = $(this).closest('.language-menu')
        $langMenu.removeClass('language-menu--open-sublist');
});

$('.language-menu__subitem').on('click', function (e) {
    document.cookie = "region-selected=1;path=/";
});


function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
